import Vue from 'vue'
import Router from 'vue-router'
import {isMobile} from '@/utils/index'

Vue.use(Router)

let kejianrouter = new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import('./views/Home.vue')
        },
        // {
        //     path: '/view',
        //     name: 'see',
        //     component: () => import('./views/view.vue')
        // },
    ]
})

let mobileRoutes = new Router({
    routes: [
        {
            path: '/',
            name: 'isMobile',
            component: () => import('./views/mobile/index.vue')
        },
    ]
})

export default isMobile() ? mobileRoutes : kejianrouter